import {
  CreateMemberRoundInput,
  CreateGuestRoundInput,
  NewGuestRoundInput,
} from "../../hooks/useCreateDraftLessonBooking/__generated__/useCreateDraftLessonBookingMutation.graphql";
import { BookingWizard } from "../../types";
import { ClientType } from "./types";

export const processPrivateLessonBookingRounds = <
  T extends CreateMemberRoundInput | CreateGuestRoundInput | NewGuestRoundInput
>(
  rounds: BookingWizard.LessonRound[] | undefined,
  clientTypes: ClientType[],
  additionalProps?: (round: BookingWizard.LessonRound) => Partial<T>
): T[] => {
  return (
    rounds
      ?.filter((round) => clientTypes.includes(round.player.clientType))
      .map(
        (round) =>
          ({
            ...(round.id ? { id: round.id } : {}),
            index: round.index,
            nonPlayingHost:
              round.player.clientType === "member"
                ? round.player.nonPlayingHost
                : undefined,
            playerId:
              round.player.clientType === "newGuest" ||
              round.player.clientType === "memberHold" ||
              round.player.clientType === "unknownGuest"
                ? undefined
                : round.player.id,
            rateId: round.rate?.id ?? null,
            ...(additionalProps ? additionalProps(round) : {}),
          } as T)
      ) ?? []
  );
};
